/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'


// Composables
import { createVuetify } from 'vuetify'
// These components are now imported from 'vuetify/components'
import { VDataTable } from 'vuetify/components'
import { VDataTableServer } from 'vuetify/components'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { md3 } from 'vuetify/blueprints'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  blueprint: md3,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    }
  },
  theme: {
    variations: {
      colors: ['primary', 'secondary', 'detail'],
      lighten: 3,
      darken: 3,
    },
    themes: {
      light: {
        colors: {
          primary: '#17A2B8',
          secondary: '#5CBBF6',
          detail: '#9C9C9C',
        },
      },
      dark: {
        colors: {
          detail: '#222222',
        },
      },
    },
  },
  components: {
    VDataTable,
    VDataTableServer
  }
})
